module.exports = __webpack_public_path__ + "img/Feature.ffb3177d.png";